export const getErrorCode = state => state.formCommon.errorCode
export const getError = state => state.formCommon.error
export const getProcessed = state => state.formCommon.processed
export const getDisabledForm = state => state.formCommon.disabledForm
